module.exports = __webpack_public_path__ + "img/20190725161946353.1ea2b39d.png";